import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Link } from "react-router-dom";
import Footer from "../Global/Footer";
import Header from "../Global/Header";
export default function Profile() {
  return (
    <>
      <Header />

      <Tabs>
        <TabList>
          <Tab>Edit Profile</Tab>
          <Tab>Staking</Tab>
        </TabList>
        <TabPanel>
          <div className="container-xl px-4 mt-4">
            <div className="row">
              <div className="col-xl-12">
                {/* <!-- Account details card--> */}
                <div className="card mb-4">
                  <div className="card-header">Account Details</div>
                  <div className="card-body">
                    <form>
                      {/* <!-- Form Group (username)--> */}
                      <div className="mb-3">
                        <label className="small mb-1" htmlFor="inputUsername">
                          Username (how your name will appear to other users on
                          the site)
                        </label>
                        <input
                          className="form-control"
                          id="inputUsername"
                          type="text"
                          placeholder="Enter your username"
                        />
                      </div>
                      {/* <!-- Form Row--> */}
                      <div className="row gx-3 mb-3">
                        {/* <!-- Form Group (first name)--> */}
                        <div className="col-md-6 name-col">
                          <label
                            className="small mb-1"
                            htmlFor="inputFirstName"
                          >
                            First name
                          </label>
                          <input
                            className="form-control"
                            id="inputFirstName"
                            type="text"
                            placeholder="Enter your first name"
                          />
                        </div>
                        {/* <!-- Form Group (last name)--> */}
                        <div className="col-md-6 last-name">
                          <label className="small mb-1" htmlFor="inputLastName">
                            Last name
                          </label>
                          <input
                            className="form-control"
                            id="inputLastName"
                            type="text"
                            placeholder="Enter your last name"
                          />
                        </div>
                      </div>
                      {/* <!-- Form Row        --> */}

                      {/* <!-- Form Group (email address)--> */}
                      <div className="mb-3">
                        <label
                          className="small mb-1"
                          htmlFor="inputEmailAddress"
                        >
                          Email address
                        </label>
                        <input
                          className="form-control"
                          id="inputEmailAddress"
                          type="email"
                          placeholder="Enter your email address"
                        />
                      </div>
                      {/* <!-- Form Row--> */}
                      <div className="row gx-3 mb-3">
                        {/* <!-- Form Group (phone number)--> */}
                        {/* <div className="col-md-6 phn">
                          <label className="small mb-1" htmlFor="inputPhone">
                            Phone number (Optional)
                          </label>
                          <input
                            className="form-control"
                            id="inputPhone"
                            type="tel"
                            placeholder="Enter your phone number"
                          />
                        </div> */}
                        {/* <!-- Form Group (birthday)--> */}
                        {/* <div className="col-md-6">
                      <label className="small mb-1" htmlFor="inputBirthday">
                        Birthday
                      </label>
                      <input
                        className="form-control"
                        id="inputBirthday"
                        type="text"
                        name="birthday"
                        placeholder="Enter your birthday"
                        value="06/10/1988"
                      />
                    </div> */}
                      </div>
                      {/* <!-- Save changes button--> */}
                      <Link
                        className="btn btn-grad btn-md submit-profile profile_btn"
                        to="/"
                      >
                        <button className="custom-btn btn-banner header header_top_btn large_screen_navbar mint_submit ">
                          Submit
                        </button>
                      </Link>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </TabPanel>
        <TabPanel></TabPanel>
      </Tabs>
      <Footer />
    </>
  );
}
